import { createAction } from 'redux-actions'

export const RECEIVE_COMMENTS = createAction('RECEIVE_COMMENTS')
export const ADD_COMMENT = createAction('ADD_COMMENT')
export const CACHE_COMMENT = createAction('CACHE_COMMENT')

export const getComments = (value, items, position) => {
  return (dispatch) => dispatch(RECEIVE_COMMENTS({value, items, position}))
}

export const addComment = (comment) => {
  return (dispatch) => dispatch(ADD_COMMENT({comment}))
}

export const cacheComment = (comment) => {
  return (dispatch) => dispatch(CACHE_COMMENT(comment))
}



// WEBPACK FOOTER //
// ./src/actions/comments.js